import { overflow } from "@prismicio/editor-support/String"
import { Card, CardContent, Text } from "@prismicio/editor-ui"

import { metaDescriptionConfig, metaTitleConfig } from "../../service"

interface MetadataPreviewProps {
  title: string
  description: string
}

export function MetadataPreview(props: MetadataPreviewProps) {
  const { title, description } = props

  return (
    <Card paddingBlock={8} paddingInline={8} variant="highlighted">
      <CardContent gap={4}>
        <Text color="indigo11" variant="h4" noSelect>
          {overflow(title, metaTitleConfig.max)}
        </Text>
        <Text color="green11" noSelect>
          https://www.yourdomain.com/
        </Text>
        <Text variant="small" color="grey11" noSelect>
          {overflow(description, metaDescriptionConfig.max)}
        </Text>
      </CardContent>
    </Card>
  )
}
